/* ==========================================================================
   Palmora — KHUNG TRANG (JS thuần, không thư viện)
   1. Thanh thông báo: nhiều thông điệp thì trượt dọc theo data-interval, mũi tên
      chuyển tay; dừng khi rê chuột / focus bàn phím / tab ẩn; tắt tự chạy khi
      người xem bật "giảm chuyển động".
   2. Header: drawer mobile (aria-expanded, Esc đóng, giữ focus trong drawer, lớp phủ),
      menu con <details> tự đóng khi bấm ra ngoài / Esc, header dính
      (data-sticky = always | scroll-up | none), bong bóng số lượng giỏ hàng.
   3. Khởi tạo lại khi Theme Editor nạp/gỡ section.
   Sự kiện công khai cho section khác (ví dụ thêm vào giỏ bằng AJAX):
     document.dispatchEvent(new CustomEvent('pm:cart-updated', { detail: { item_count: 2 } }));
   Không truyền item_count thì file này tự đọc /cart.js.
   ========================================================================== */
(function () {
  'use strict';

  /* File có thể được nạp nhiều lần — chỉ chạy một lần */
  if (window.__pmChromeLoaded) return;
  window.__pmChromeLoaded = true;

  var reduceMotion = false;
  try {
    reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch (e) { /* trình duyệt cũ */ }

  function each(list, fn) {
    for (var i = 0; i < list.length; i++) fn(list[i]);
  }

  function isKeyboardFocus(target) {
    try {
      return target.matches(':focus-visible');
    } catch (e) {
      return false;
    }
  }

  function listenMedia(mq, fn) {
    if (!mq) return function () {};
    if (mq.addEventListener) {
      mq.addEventListener('change', fn);
      return function () { mq.removeEventListener('change', fn); };
    }
    if (mq.addListener) {
      mq.addListener(fn);
      return function () { mq.removeListener(fn); };
    }
    return function () {};
  }

  /* ------------------------------------------------------------------
     1. Thanh thông báo
     ------------------------------------------------------------------ */
  function initAnnounce(el) {
    if (el.__pmAnnounce) return;
    var api = { destroy: function () {} };
    el.__pmAnnounce = api;

    var slides = Array.prototype.slice.call(el.querySelectorAll('[data-pm-announce-slide]'));
    if (slides.length < 2) return;

    var index = 0;
    for (var i = 0; i < slides.length; i++) {
      if (slides[i].classList.contains('is-active')) { index = i; break; }
    }

    var interval = parseInt(el.getAttribute('data-interval'), 10);
    if (!interval || interval < 1000) interval = 5000;
    var autoplay = el.getAttribute('data-autoplay') === 'true' && !reduceMotion;
    var duration = reduceMotion ? 0 : 500;

    var timer = null;
    var cleanupTimer = null;
    var leaving = null;
    var hovered = false;
    var focused = false;
    var selected = false;
    var stopped = false; /* người dùng bàn phím tự chuyển => dừng hẳn tự chạy (WCAG 2.2.2) */

    function finish() {
      if (cleanupTimer) { clearTimeout(cleanupTimer); cleanupTimer = null; }
      if (leaving) {
        leaving.classList.remove('is-leave-up', 'is-leave-down');
        leaving = null;
      }
    }

    function go(target, dir) {
      target = (target % slides.length + slides.length) % slides.length;
      if (target === index) return;
      finish();
      var cur = slides[index];
      var nxt = slides[target];

      /* Đặt slide mới ở vị trí xuất phát (không transition), ép reflow, rồi trượt vào */
      nxt.classList.add(dir < 0 ? 'is-enter-above' : 'is-enter-below');
      void nxt.offsetWidth;
      nxt.classList.remove('is-enter-above', 'is-enter-below');
      nxt.classList.add('is-active');
      nxt.removeAttribute('aria-hidden');

      cur.classList.remove('is-active');
      cur.classList.add(dir < 0 ? 'is-leave-down' : 'is-leave-up');
      cur.setAttribute('aria-hidden', 'true');

      leaving = cur;
      cleanupTimer = setTimeout(finish, duration + 50);
      index = target;
    }

    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    function sync() {
      stop();
      if (!autoplay || stopped || hovered || focused || selected || document.hidden) return;
      timer = setInterval(function () { go(index + 1, 1); }, interval);
    }

    var prev = el.querySelector('[data-pm-announce-prev]');
    var next = el.querySelector('[data-pm-announce-next]');

    /* Kích hoạt bằng bàn phím (click có detail 0) => người dùng tự điều khiển, dừng tự chạy */
    function manual(e) {
      if (e && e.detail === 0) stopped = true;
    }
    function onPrev(e) { e.preventDefault(); manual(e); go(index - 1, -1); sync(); }
    function onNext(e) { e.preventDefault(); manual(e); go(index + 1, 1); sync(); }

    /* Chỉ chuột thật mới tính là "rê chuột" (chạm sinh mouseenter giả không có mouseleave) */
    var usePointer = typeof window.PointerEvent === 'function';
    var enterEvt = usePointer ? 'pointerenter' : 'mouseenter';
    var leaveEvt = usePointer ? 'pointerleave' : 'mouseleave';
    function onEnter(e) {
      if (usePointer && e.pointerType !== 'mouse') return;
      hovered = true; sync();
    }
    function onLeave(e) {
      if (usePointer && e.pointerType !== 'mouse') return;
      hovered = false; sync();
    }
    function onFocusIn(e) {
      if (isKeyboardFocus(e.target)) { focused = true; sync(); }
    }
    function onFocusOut(e) {
      if (!e.relatedTarget || !el.contains(e.relatedTarget)) { focused = false; sync(); }
    }
    function onVisibility() { sync(); }

    /* Theme Editor: chọn block nào thì hiện thông điệp đó và dừng tự chạy */
    function onBlockSelect(e) {
      var slide = e.target && e.target.closest ? e.target.closest('[data-pm-announce-slide]') : null;
      var idx = slides.indexOf(slide);
      if (idx === -1) return;
      selected = true;
      go(idx, idx > index ? 1 : -1);
      sync();
    }
    function onBlockDeselect() { selected = false; sync(); }

    if (prev) prev.addEventListener('click', onPrev);
    if (next) next.addEventListener('click', onNext);
    el.addEventListener(enterEvt, onEnter);
    el.addEventListener(leaveEvt, onLeave);
    el.addEventListener('focusin', onFocusIn);
    el.addEventListener('focusout', onFocusOut);
    el.addEventListener('shopify:block:select', onBlockSelect);
    el.addEventListener('shopify:block:deselect', onBlockDeselect);
    document.addEventListener('visibilitychange', onVisibility);

    api.destroy = function () {
      stop();
      finish();
      if (prev) prev.removeEventListener('click', onPrev);
      if (next) next.removeEventListener('click', onNext);
      el.removeEventListener(enterEvt, onEnter);
      el.removeEventListener(leaveEvt, onLeave);
      el.removeEventListener('focusin', onFocusIn);
      el.removeEventListener('focusout', onFocusOut);
      el.removeEventListener('shopify:block:select', onBlockSelect);
      el.removeEventListener('shopify:block:deselect', onBlockDeselect);
      document.removeEventListener('visibilitychange', onVisibility);
    };

    sync();
  }

  /* ------------------------------------------------------------------
     2. Header
     ------------------------------------------------------------------ */
  function initHeader(el) {
    if (el.__pmHeader) return;
    var api = { destroy: function () {} };
    el.__pmHeader = api;

    var root = document.documentElement;
    var toggle = el.querySelector('[data-pm-drawer-toggle]');
    var drawer = el.querySelector('[data-pm-drawer]');
    var overlay = el.querySelector('[data-pm-drawer-overlay]');
    var section = el.closest ? el.closest('.shopify-section') : null;
    var mode = el.getAttribute('data-sticky') || 'none';
    var sticky = (mode === 'always' || mode === 'scroll-up') && !!section;
    var hideOnScroll = sticky && mode === 'scroll-up';
    var isOpen = false;
    var mq = null;
    try { mq = window.matchMedia('(min-width: 990px)'); } catch (e) { mq = null; }

    /* ---- Menu con <details> ---- */
    var dropdowns = Array.prototype.slice.call(el.querySelectorAll('[data-pm-dropdown]'));
    function closeDropdowns(except) {
      dropdowns.forEach(function (d) {
        if (d !== except && d.hasAttribute('open')) d.removeAttribute('open');
      });
    }
    function onDocClick(e) {
      if (!dropdowns.length) return;
      var inside = e.target && e.target.closest ? e.target.closest('[data-pm-dropdown]') : null;
      closeDropdowns(inside);
    }
    function onDropdownToggle(e) {
      if (e.target.hasAttribute('open')) closeDropdowns(e.target);
    }
    dropdowns.forEach(function (d) { d.addEventListener('toggle', onDropdownToggle); });

    /* ---- Drawer mobile ---- */
    function setDrawerTop() {
      var rect = el.getBoundingClientRect();
      el.style.setProperty('--pm-drawer-top', Math.max(0, Math.round(rect.bottom)) + 'px');
    }

    /* Mọi phần tử focus được đang HIỆN trong header + drawer, theo thứ tự DOM */
    function focusables() {
      var list = el.querySelectorAll('a[href], button:not([disabled]), summary, [tabindex]:not([tabindex="-1"])');
      var out = [];
      for (var i = 0; i < list.length; i++) {
        var n = list[i];
        if (!n.getClientRects().length) continue;
        if (window.getComputedStyle(n).visibility === 'hidden') continue;
        out.push(n);
      }
      return out;
    }

    function open() {
      if (!toggle || !drawer || isOpen) return;
      if (section) {
        /* Cắt ngang transition ẩn/hiện để đo đúng vị trí đáy header */
        section.style.transition = 'none';
        section.classList.remove('is-hidden');
        void section.offsetWidth;
      }
      setDrawerTop();
      if (section) section.style.transition = '';
      isOpen = true;
      el.classList.add('is-drawer-open');
      if (section) section.classList.add('is-drawer-open');
      root.classList.add('pm-scroll-lock');
      toggle.setAttribute('aria-expanded', 'true');
      toggle.setAttribute('aria-label', toggle.getAttribute('data-label-close') || 'Close menu');
      var first = drawer.querySelector('a[href], button, summary');
      if (first) {
        setTimeout(function () {
          try { first.focus({ preventScroll: true }); } catch (e) { first.focus(); }
        }, 60);
      }
    }

    function close(returnFocus) {
      if (!isOpen) return;
      isOpen = false;
      el.classList.remove('is-drawer-open');
      if (section) section.classList.remove('is-drawer-open');
      root.classList.remove('pm-scroll-lock');
      if (toggle) {
        toggle.setAttribute('aria-expanded', 'false');
        toggle.setAttribute('aria-label', toggle.getAttribute('data-label-open') || 'Open menu');
        if (returnFocus) toggle.focus();
      }
    }

    function onToggle(e) {
      e.preventDefault();
      if (isOpen) close(false); else open();
    }

    function onKey(e) {
      if (e.key === 'Escape' || e.key === 'Esc') {
        if (isOpen) { close(true); return; }
        var openDrop = null;
        dropdowns.forEach(function (d) { if (d.hasAttribute('open')) openDrop = d; });
        if (openDrop) {
          openDrop.removeAttribute('open');
          var summary = openDrop.querySelector('summary');
          if (summary) summary.focus();
        }
        return;
      }
      if (!isOpen || e.key !== 'Tab') return;
      /* Giữ focus trong header + drawer khi drawer mở */
      var items = focusables();
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      var active = document.activeElement;
      var inside = el.contains(active);
      if (e.shiftKey && (!inside || active === first)) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && (!inside || active === last)) {
        e.preventDefault();
        first.focus();
      }
    }

    function onFocusOut(e) {
      if (isOpen && e.relatedTarget && !el.contains(e.relatedTarget)) close(false);
      /* Menu con desktop: rời focus khỏi menu thì đóng */
      dropdowns.forEach(function (d) {
        if (d.hasAttribute('open') && e.relatedTarget && !d.contains(e.relatedTarget)) d.removeAttribute('open');
      });
    }
    function onOverlay() { close(false); }
    function onDrawerClick(e) {
      var link = e.target && e.target.closest ? e.target.closest('a[href]') : null;
      if (link) close(false);
    }
    function onMedia(e) {
      if (e.matches) close(false);
      closeDropdowns(null);
    }

    if (toggle) toggle.addEventListener('click', onToggle);
    if (overlay) overlay.addEventListener('click', onOverlay);
    if (drawer) drawer.addEventListener('click', onDrawerClick);
    document.addEventListener('keydown', onKey);
    document.addEventListener('click', onDocClick);
    el.addEventListener('focusout', onFocusOut);
    var unMedia = listenMedia(mq, onMedia);

    /* ---- Header dính ---- */
    var lastY = window.pageYOffset || 0;
    var ticking = false;

    function threshold() {
      var ann = document.querySelector('[data-pm-announce]');
      return section.offsetHeight + (ann ? ann.offsetHeight : 0);
    }

    function update() {
      ticking = false;
      var y = window.pageYOffset || root.scrollTop || 0;
      if (isOpen) { lastY = y; return; }
      var dy = y - lastY;
      if (y <= threshold()) {
        section.classList.remove('is-hidden');
      } else if (Math.abs(dy) < 5) {
        return;
      } else if (dy > 0) {
        section.classList.add('is-hidden');
        closeDropdowns(null);
      } else {
        section.classList.remove('is-hidden');
      }
      lastY = y;
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }
    function onFocusIn() {
      if (section) section.classList.remove('is-hidden');
    }

    /* Ghi chiều cao header dính ra --pm-header-h để neo cuộn (#faq...) không bị header che */
    var ro = null;
    var sizeTick = false;
    function setHeaderHeight() {
      sizeTick = false;
      root.style.setProperty('--pm-header-h', Math.round(section.offsetHeight) + 'px');
    }
    function onResize() {
      if (sizeTick) return;
      sizeTick = true;
      window.requestAnimationFrame(setHeaderHeight);
    }

    if (sticky) {
      section.classList.add('pm-header-sticky');
      setHeaderHeight();
      if (typeof window.ResizeObserver === 'function') {
        ro = new window.ResizeObserver(onResize);
        ro.observe(section);
      } else {
        window.addEventListener('resize', onResize);
        window.addEventListener('load', onResize);
      }
      if (hideOnScroll) {
        window.addEventListener('scroll', onScroll, { passive: true });
        el.addEventListener('focusin', onFocusIn);
      }
    }

    api.destroy = function () {
      close(false);
      if (toggle) toggle.removeEventListener('click', onToggle);
      if (overlay) overlay.removeEventListener('click', onOverlay);
      if (drawer) drawer.removeEventListener('click', onDrawerClick);
      document.removeEventListener('keydown', onKey);
      document.removeEventListener('click', onDocClick);
      el.removeEventListener('focusout', onFocusOut);
      dropdowns.forEach(function (d) { d.removeEventListener('toggle', onDropdownToggle); });
      unMedia();
      if (sticky) {
        if (ro) { ro.disconnect(); ro = null; }
        window.removeEventListener('resize', onResize);
        window.removeEventListener('load', onResize);
        window.removeEventListener('scroll', onScroll);
        el.removeEventListener('focusin', onFocusIn);
        root.style.removeProperty('--pm-header-h');
        section.classList.remove('pm-header-sticky', 'is-hidden', 'is-drawer-open');
      }
    };
  }

  /* ------------------------------------------------------------------
     3. Bong bóng số lượng giỏ hàng
     ------------------------------------------------------------------ */
  function renderCartCount(count) {
    count = parseInt(count, 10) || 0;
    each(document.querySelectorAll('[data-pm-cart-count]'), function (bubble) {
      bubble.textContent = count > 99 ? '99+' : String(count);
      bubble.hidden = count === 0;
    });
    each(document.querySelectorAll('[data-pm-cart-link]'), function (link) {
      var one = link.getAttribute('data-label-one') || 'Cart, 1 item';
      var other = link.getAttribute('data-label-other') || 'Cart, [count] items';
      link.setAttribute('aria-label', count === 1 ? one : other.replace('[count]', count));
    });
  }

  document.addEventListener('pm:cart-updated', function (e) {
    var detail = e && e.detail ? e.detail : null;
    if (detail && typeof detail.item_count !== 'undefined') {
      renderCartCount(detail.item_count);
      return;
    }
    if (!window.fetch) return;
    var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(rootUrl + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCartCount(cart.item_count); })
      .catch(function () { /* giữ nguyên số cũ */ });
  });

  /* ------------------------------------------------------------------
     4. Khởi tạo + vòng đời trong Theme Editor
     ------------------------------------------------------------------ */
  function initAll(scope) {
    scope = scope || document;
    if (!scope.querySelectorAll) return;
    each(scope.querySelectorAll('[data-pm-announce]'), initAnnounce);
    each(scope.querySelectorAll('[data-pm-header]'), initHeader);
  }

  function destroyAll(scope) {
    if (!scope || !scope.querySelectorAll) return;
    each(scope.querySelectorAll('[data-pm-announce]'), function (el) {
      if (el.__pmAnnounce) { el.__pmAnnounce.destroy(); el.__pmAnnounce = null; }
    });
    each(scope.querySelectorAll('[data-pm-header]'), function (el) {
      if (el.__pmHeader) { el.__pmHeader.destroy(); el.__pmHeader = null; }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) { destroyAll(e.target); });
})();
